import { createFileRoute } from "@tanstack/react-router";
import { TeamComparisonPage } from "@/pages/dashboard/teamcomparison/page";

export const Route = createFileRoute("/_pathlessLayout/dashboard/teamcomparison")({
    component: TeamComparisonPage,
});
